"use client";
import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useTranslations } from "next-intl";
import { CANDLE_COLOR } from "@/app/theme/theme";
import { getBitcoinData } from "@/lib/cryptoData/bitcoin";
import { getEthereumData } from "@/lib/cryptoData/ethereum";
import { getSolanaData } from "@/lib/cryptoData/solana";
import { formatNumber } from "@/lib/formatNumber";

export default function CryptoOverviewPanel({ crypto }: { crypto: string }) {
  const t = useTranslations();
  const [data, setData] = useState<any>();

  useEffect(() => {
    async function fetchData() {
      if (crypto === "btc") {
        setData(await getBitcoinData());
      } else if (crypto === "eth") {
        setData(await getEthereumData());
      } else if (crypto === "sol") {
        setData(await getSolanaData());
      }
    }
    fetchData();
  }, [crypto]);

  const priceColor = data?.change24h >= 0 ? CANDLE_COLOR.BULLISH : CANDLE_COLOR.BEARISH;

  return (
    <Box sx={{ 
      display: "flex", 
      flexWrap: { xs: "wrap", sm: "nowrap" }, // 小屏幕时启用换行
      gap: { xs: 1.5, sm: 7.25 }, 
      alignItems: "start",
      width: "100%"
    }}>
      <Box sx={{ 
        width: { xs: "calc(50% - 0.75rem)", sm: "auto" }, // 小屏幕时宽度为50%减去间距
      }}>
        <Typography
          variant="body2"
          sx={{ fontWeight: 600, textTransform: "uppercase", color: "text.secondary", mb: 0.5 }}>
          {t("Analytics.tab1.summary.price")}
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 600, color: priceColor }}>
          {formatNumber(data?.price)}
        </Typography>
      </Box>
      <Box sx={{ 
        width: { xs: "calc(50% - 0.75rem)", sm: "auto" },
      }}>
        <Typography
          variant="body2"
          sx={{ fontWeight: 600, textTransform: "uppercase", color: "text.secondary", mb: 0.5 }}>
          {t("Analytics.tab1.summary.change")}
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 600, color: priceColor }}>
          {data?.change24h && data?.change24h.toFixed(2) + "%"}
        </Typography>
      </Box>
      <Box sx={{ 
        width: { xs: "calc(50% - 0.75rem)", sm: "auto" },
        gap: 1 
      }}>
        <Typography
          variant="body2"
          sx={{ fontWeight: 600, textTransform: "uppercase", color: "text.secondary", mb: 0.5 }}>
          {t("Analytics.tab1.summary.volumn")}
        </Typography>

        <Box sx={{ display: "flex", gap: {xs: 1, sm: 2, md: 4} }}>
          <Box sx={{ display: "flex", gap: 0.5 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {formatNumber(data?.volume24h?.count, true)}
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 600, color: "text.secondary" }}>
              {crypto.toUpperCase()}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", gap: 0.5 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {formatNumber(data?.volume24h?.usdt, true)}
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 600, color: "text.secondary" }}>
              USD
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box sx={{ 
        width: { xs: "calc(50% - 0.75rem)", sm: "auto" },
        gap: 1 
      }}>
        <Typography
          variant="body2"
          sx={{ fontWeight: 600, textTransform: "uppercase", color: "text.secondary", mb: 0.5 }}>
          {t("Analytics.tab1.summary.supply")}
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {formatNumber(data?.circulatingSupply)}
        </Typography>
      </Box>
    </Box>
  );
}
